// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Qfoz","label":"Category_label__2qfS6","content":"Category_content__2YjBd","header":"Category_header__30v9k","location":"Category_location__34uJP"};